<!-- <app-navbar></app-navbar> -->
<app-carousel></app-carousel>
 <!-- Games Data -->
 <div class="card  bg-dark text-white mt-3">
    <div class="card-header border-warning">Cricket<span class="ml-1 badge badge-warning">6</span></div>
    <div class="card-body" (click)="matchDetail()">
        <div>
            <div class="border-body p-2">
                <button class="btn btn-success mr-2">In-Play</button>India v Australia
                <div class="d-flex justify-content-between mt-2">
                    <div class="p-2 flexitem bg-warning"> item 1</div>
                    <div class="p-2 flexitem bg-info"> item 2</div>
                    <div class="p-2 flexitem bg-warning"> item 3</div>
                    <div class="p-2 flexitem bg-info"> item 4</div>
                    <div class="p-2 flexitem bg-warning"> item 5</div>
                    <div class="p-2 flexitem bg-info"> item 6</div>
                </div>
            </div>   
        </div>
    </div>
    <div class="card-body pt-1">
        <div>
            <div class="border-body p-2">
                <button class="btn btn-outline-light date mr-2">FEB 10 <br> 10:00 PM</button>India v Australia
                <div class="d-flex justify-content-between mt-2">
                    <div class="p-2 flexitem bg-warning"> item 1</div>
                    <div class="p-2 flexitem bg-info"> item 2</div>
                    <div class="p-2 flexitem bg-warning"> item 3</div>
                    <div class="p-2 flexitem bg-info"> item 4</div>
                    <div class="p-2 flexitem bg-warning"> item 5</div>
                    <div class="p-2 flexitem bg-info"> item 6</div>
                </div>
            </div>   
        </div>
    </div>
    
</div>
<div class="card mt-3 bg-dark text-white">
    <div class="card-header  border-warning">Tennis<span class=" ml-1 badge badge-warning">6</span></div>
    <div class="card-body">
        <div>
            <div class="border-body p-2">
                <button class="btn btn-success mr-2">In-Play</button>India v Australia
                <div class="d-flex justify-content-between mt-2">
                    <div class="p-2 flexitem bg-warning"> item 1</div>
                    <div class="p-2 flexitem bg-info"> item 2</div>
                    <div class="p-2 flexitem bg-warning"> item 3</div>
                    <div class="p-2 flexitem bg-info"> item 4</div>
                    <div class="p-2 flexitem bg-warning"> item 5</div>
                    <div class="p-2 flexitem bg-info"> item 6</div>
                </div>
            </div>   
        </div>
    </div>
    <div class="card-body pt-1">
        <div>
            <div class="border-body p-2">
                <button class="btn btn-outline-light date mr-2">FEB 10 <br> 10:00 PM</button>India v Australia
                <div class="d-flex justify-content-between mt-2">
                    <div class="p-2 flexitem bg-warning"> item 1</div>
                    <div class="p-2 flexitem bg-info"> item 2</div>
                    <div class="p-2 flexitem bg-warning"> item 3</div>
                    <div class="p-2 flexitem bg-info"> item 4</div>
                    <div class="p-2 flexitem bg-warning"> item 5</div>
                    <div class="p-2 flexitem bg-info"> item 6</div>
                </div>
            </div>   
        </div>
    </div>
    
</div>
<div class="card mt-3 bg-dark text-white">
    <div class="card-header  border-warning">Tennis<span class=" ml-1 badge badge-warning">6</span></div>
    <div class="card-body">
        <div>
            <div class="border-body p-2">
                <button class="btn btn-success mr-2">In-Play</button>India v Australia
                <div class="d-flex justify-content-between mt-2">
                    <div class="p-2 flexitem bg-warning"> item 1</div>
                    <div class="p-2 flexitem bg-info"> item 2</div>
                    <div class="p-2 flexitem bg-warning"> item 3</div>
                    <div class="p-2 flexitem bg-info"> item 4</div>
                    <div class="p-2 flexitem bg-warning"> item 5</div>
                    <div class="p-2 flexitem bg-info"> item 6</div>
                </div>
            </div>   
        </div>
    </div>
    <div class="card-body pt-1">
        <div>
            <div class="border-body p-2">
                <button class="btn btn-outline-light date mr-2">FEB 10 <br> 10:00 PM</button>India v Australia
                <div class="d-flex justify-content-between mt-2">
                    <div class="p-2 flexitem bg-warning"> item 1</div>
                    <div class="p-2 flexitem bg-info"> item 2</div>
                    <div class="p-2 flexitem bg-warning"> item 3</div>
                    <div class="p-2 flexitem bg-info"> item 4</div>
                    <div class="p-2 flexitem bg-warning"> item 5</div>
                    <div class="p-2 flexitem bg-info"> item 6</div>
                </div>
            </div>   
        </div>
    </div>
    <div class="card-body pt-1">
        <div>
            <div class="border-body p-2">
                <button class="btn btn-outline-light date mr-2">FEB 10 <br> 10:00 PM</button>India v Australia
                <div class="d-flex justify-content-between mt-2">
                    <div class="p-2 flexitem bg-warning"> item 1</div>
                    <div class="p-2 flexitem bg-info"> item 2</div>
                    <div class="p-2 flexitem bg-warning"> item 3</div>
                    <div class="p-2 flexitem bg-info"> item 4</div>
                    <div class="p-2 flexitem bg-warning"> item 5</div>
                    <div class="p-2 flexitem bg-info"> item 6</div>
                </div>
            </div>   
        </div>
    </div>
    <div class="card-body pt-1">
        <div>
            <div class="border-body p-2">
                <button class="btn btn-outline-light date mr-2">FEB 10 <br> 10:00 PM</button>India v Australia
                <div class="d-flex justify-content-between mt-2">
                    <div class="p-2 flexitem bg-warning"> item 1</div>
                    <div class="p-2 flexitem bg-info"> item 2</div>
                    <div class="p-2 flexitem bg-warning"> item 3</div>
                    <div class="p-2 flexitem bg-info"> item 4</div>
                    <div class="p-2 flexitem bg-warning"> item 5</div>
                    <div class="p-2 flexitem bg-info"> item 6</div>
                </div>
            </div>   
        </div>
    </div>
    
</div>
<!-- Games Data -->

<!-- <app-footer></app-footer> -->